import React from 'react';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import IconButton from '@mui/material/IconButton';
import { UserPortalContext } from '../../context/appcontext';
import { makeStyles } from '@material-ui/core/styles';
import downloadIcon from '../../assets/SVGs/download-icon.svg';
import { Typography } from '@material-ui/core';
import PropTypes from 'prop-types';
import {
	getWeek,
	getEventTrackingAttribute,
	getEventTrackingDescription,
} from './utils';
import analytics from '../../helper/analytics';
import tracker from '../../constants/tracker';
import {
	ExcelFile,
	ExcelSheet,
	ExcelColumn,
} from '../../common/components/export-to-excel/index';
import { useSelector, useDispatch } from 'react-redux';
import { saveEventTrack } from '../../redux/actions/eventTrackAction';
const useStyles = makeStyles(() => ({
	button_ellipsis: {
		width: '40px',
		height: '40px',
	},
	menuOptions: {
		fontFamily: 'Bogle-Regular',
		fontSize: '16px',
		lineHeight: '16px',
	},
}));
const DownloadMap = ({
	data,
	chartTitle,
	weekFilter,
	category,
	inStock,
	isNetSales,
	brandName,
	upcNumber,
	selectedTab,
}) => {
	const classes = useStyles({});
	const dispatch = useDispatch();
	const [anchorEl, setAnchorEl] = React.useState(null);
	const selectedFilters = useSelector(
		(state) => state.salesReducer.selectedFilters
	);
	const { startWeek, endWeek } = selectedFilters;
	const portalUserContext = React.useContext(UserPortalContext);
	const parentCompanyName = portalUserContext?.result?.companyName;
	const downloadTime = new Date().toLocaleString().replace(',', ' ');
	const fileName = `${chartTitle}-Scintilla-Channel Performance-${downloadTime}`;
	const open = Boolean(anchorEl);
	const kpiName = useSelector((state) => state.salesReducer.kpiName);
	const handleClick = (event) => {
		setAnchorEl(event.currentTarget);
		analytics.trackEventInfo({
			type: tracker.EVENTS.CLICK,
			actionOn: tracker.ACTION_ON.EXPORT_BUTTON,
			location: `${chartTitle}`,
		});
	};
	const handleClose = () => {
		setAnchorEl(null);
	};
	const handleOnClick = () => {
		setAnchorEl(null);
		const request = {
			event: 'DOWNLOADS',
			event_description: getEventTrackingDescription(chartTitle, selectedTab),
			attributes: getEventTrackingAttribute(selectedTab, kpiName, ''),
		};
		dispatch(saveEventTrack({ request, portalUserContext }));
	};
	const metaData = [
		{
			parentCompany: parentCompanyName,
			catName: category,
			timeframe: getWeek(weekFilter, startWeek, endWeek),
			metricName: `${brandName || ''}${upcNumber || ''} ${chartTitle}`,
			fileGenerationTimestamp: `${downloadTime}`,
			note: `The downloaded data is governed by contract terms between Scintilla and ${parentCompanyName}`,
		},
	];
	let excelSheet = (
		<ExcelSheet data={data} name="Data">
			<ExcelColumn label="State" value="name" />
			<ExcelColumn label="Value" value="mainValue" />
			<ExcelColumn label="Change" value="change" />
			<ExcelColumn label="Top Store Number" value="topStoreNo" />
			<ExcelColumn label="Top Store Value" value="topStoreValue" />
			<ExcelColumn label="Bottom Store Number" value="bottomStoreNo" />
			<ExcelColumn label="Bottom Store Value" value="bottomStoreValue" />
		</ExcelSheet>
	);
	if (inStock) {
		excelSheet = (
			<ExcelSheet data={data} name="Data">
				<ExcelColumn label="State" value="state" />
				<ExcelColumn label="This year value (%)" value="thisYear" />
				<ExcelColumn label="Last year value (%)" value="lastYear" />
				<ExcelColumn label="Change (%)" value="change" />
			</ExcelSheet>
		);
	}
	if (isNetSales) {
		excelSheet = (
			<ExcelSheet data={data} name="Data">
				<ExcelColumn label="State" value="name" />
				<ExcelColumn label="This year value ($)" value="tyValue" />
				<ExcelColumn label="Last year value ($)" value="lyValue" />
				<ExcelColumn label="Change (%)" value="change" />
				<ExcelColumn label="Change ($)" value="absYoY" />
			</ExcelSheet>
		);
	}
	return (
		<>
			<IconButton
				size="medium"
				className={classes.button_ellipsis}
				onClick={handleClick}>
				<img alt="Download" src={downloadIcon} />
			</IconButton>
			<Menu
				id="basic-menu"
				anchorEl={anchorEl}
				open={open}
				onClose={handleClose}
				anchorOrigin={{
					vertical: 'center',
					horizontal: 'left',
				}}
				transformOrigin={{
					vertical: 'top',
					horizontal: 'right',
				}}
				MenuListProps={{
					'aria-labelledby': 'basic-button',
				}}>
				<MenuItem>
					<ExcelFile
						element={
							<Typography
								className={classes.menuOptions}
								onClick={handleOnClick}>
								Download in .XLSX
							</Typography>
						}
						filename={fileName}>
						<ExcelSheet data={metaData} name="Meta Data">
							<ExcelColumn label="Note" value="note" />
							<ExcelColumn
								label="File Generation Timestamp"
								value="fileGenerationTimestamp"
							/>
							<ExcelColumn label="Parent Company Name" value="parentCompany" />
							<ExcelColumn label="Category Name" value="catName" />
							<ExcelColumn label="Timeframe" value="timeframe" />
							<ExcelColumn label="Metric Name" value="metricName" />
						</ExcelSheet>
						{excelSheet}
					</ExcelFile>
				</MenuItem>
			</Menu>
		</>
	);
};
DownloadMap.propTypes = {
	data: PropTypes.arrayOf(PropTypes.shape({})),
	chartTitle: PropTypes.string,
	weekFilter: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	category: PropTypes.string,
	inStock: PropTypes.bool,
	isNetSales: PropTypes.bool,
	brandName: PropTypes.string,
	upcNumber: PropTypes.number,
	selectedTab: PropTypes.string,
	kpiType: PropTypes.string,
};
DownloadMap.defaultProps = {
	inStock: false,
	isNetSales: false,
	brandName: '',
	selectedTab: '',
	kpiType: '',
};

export default DownloadMap;
